import "../styles/globals.css";
import { Navigation, Theme, Footer, CookieBanner, RequestAccessBalloon, Banner, Button } from "../components";
import { styled } from "@linaria/react";
import Head from "next/head";
import type { AppProps } from "next/app";
import SEO from "../../next-seo.config";
import { DefaultSeo } from "next-seo";
import { useRouter } from "next/router";
import { useJobDispatch } from "../hooks";
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c1dn3z8p"
});

function MyApp({
  Component,
  pageProps
}: AppProps): JSX.Element {
  const router = useRouter();
  const signedUp = router.query["sign-up"];

  const hide = () => router.replace(router.basePath);

  const script = useJobDispatch();
  return <Theme>
      <div id="modal" />
      <DefaultSeo {...SEO} />
      {script}
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width, maximum-scale=1.0" />
      </Head>
      <Content>
        <Navigation />
        <Component {...pageProps} />
      </Content>
      <Footer />
      <CookieBanner />
      {signedUp && <Banner hide={hide}>
          <h4>Early access</h4>
          <p>Thank you for signing up for Fiberplane&apos;s early access!</p>
          <p>
            We will reach out to you shortly to schedule an onboarding call!
          </p>
          <p>The Fiberplane Team</p>
          <Button buttonStyle="default" buttonSize="large" onClick={hide}>
            Close
          </Button>
        </Banner>}
      <RequestAccessBalloon />
    </Theme>;
}

export default MyApp;

require("../../.linaria-cache/src/pages/_app.linaria.module.css");